import { fetchAIFlags } from './ai-flags.utils';
import isEmpty from 'lodash/isEmpty';
import keyBy from 'lodash/keyBy';

export default {
    namespaced: true,
    state: {
        subscriptionId: undefined,
        map: {},
        error: {},
        fetching: false,
    },
    mutations: {
        setSubscriptionId (state, { subscriptionId }) {
            state.subscriptionId = subscriptionId;
        },
        setMap (state, { map }) {
            state.map = map;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        async hydrate ({ dispatch, commit }, { aiSettings } = {}) {
            if (!aiSettings) {
                await dispatch('loadAll', { reFetch: true });

                return;
            }

            commit('setMap', { map: keyBy(aiSettings, 'flag') });
        },
        async loadAll ({ commit, state }, { reFetch = false, subscriptionId, isSuperSettings = false } = {}) {
            if (!isEmpty(state.map) && !reFetch && state.subscriptionId === subscriptionId) {
                return;
            }

            commit('setFetching', { fetching: true });
            try {
                commit('setSubscriptionId', { subscriptionId });
                const aiSettings = await fetchAIFlags(subscriptionId, isSuperSettings);
                commit('setFetching', { fetching: false });
                if (subscriptionId !== state.subscriptionId) {
                    commit('setSubscriptionId', { subscriptionId });
                }
                commit('setMap', { map: keyBy(aiSettings, 'flag') });
            } catch (error) {
                commit('setSubscriptionId', { subscriptionId: undefined });
                commit('setFetching', { fetching: false });
                commit('setError', { error });
                // Don't explode
            }
        },
    },
    getters: {
        aiFlagsMap: (state) => state.map,
        canEnableAIFlag: (state) => (name) => {
            const flag = state.map?.[name];

            return flag ? flag.canEnable : false;
        },
    },
};
